import { render, staticRenderFns } from "./GettingStartedIsEasy.vue?vue&type=template&id=0c7917b8&scoped=true&"
var script = {}
import style0 from "./GettingStartedIsEasy.vue?vue&type=style&index=0&id=0c7917b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c7917b8",
  null
  
)

export default component.exports